export const SET_MODULE = 'SET_MODULE';
